<!-- Version Info Modal -->
<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" *ngIf="isOpen">
  <div class="modal-backdrop fade" [class.show]="isOpen" (click)="close()"></div>
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="bi bi-info-circle me-2"></i>RARR System Version Information
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <!-- Main Tabs (Current Version / Release History) -->
        <ul class="nav nav-tabs px-3 pt-3 mb-0 border-bottom">
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedTab === 'current'"
              (click)="selectTab('current')"
            >
              <i class="bi bi-info-circle me-1"></i>Current Version
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedTab === 'history'"
              (click)="selectTab('history')"
            >
              <i class="bi bi-clock-history me-1"></i>Release History
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content p-4">
          <!-- Current Version Tab -->
          <div *ngIf="selectedTab === 'current' && currentVersion" class="tab-pane fade show active">
            <!-- Version Badge -->
            <div class="text-center mb-4">
              <div class="display-3 fw-bold text-primary">
                v{{ currentVersion.version }}
              </div>
              <p class="text-muted">
                <i class="bi bi-calendar3 me-1"></i>Built on {{ currentVersion.buildDate }}
              </p>
              <span class="badge bg-{{ currentVersion.environment === 'production' ? 'success' : 'warning' }} px-3 py-2">
                {{ currentVersion.environment | uppercase }}
              </span>
            </div>

            <!-- Release Notes -->
            <div class="card mb-3" *ngIf="currentVersion.releaseNotes">
              <div class="card-header bg-light">
                <h6 class="mb-0">
                  <i class="bi bi-journal-text me-2"></i>Release Notes
                </h6>
              </div>
              <div class="card-body">
                <p class="mb-0">{{ currentVersion.releaseNotes }}</p>
              </div>
            </div>

            <!-- Latest Release Details with Sub-tabs -->
            <div class="card" *ngIf="versionHistory.length > 0 && versionHistory[0]">
              <div class="card-header bg-light">
                <h6 class="mb-0">
                  <i class="bi bi-list-stars me-2"></i>What's New in v{{ versionHistory[0].version }}
                </h6>
              </div>
              <div class="card-body p-0">
                <!-- Sub-tabs for Summary/Backend/Frontend -->
                <ul class="nav nav-tabs px-3 pt-2 mb-0">
                  <li class="nav-item">
                    <button class="nav-link active" [class.active]="selectedReleaseTab === 'summary'" (click)="selectReleaseTab('summary')">
                      <i class="bi bi-clipboard-data me-1"></i>Summary
                    </button>
                  </li>
                  <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedReleaseTab === 'backend'" (click)="selectReleaseTab('backend')">
                      <i class="bi bi-server me-1"></i>Backend
                    </button>
                  </li>
                  <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedReleaseTab === 'frontend'" (click)="selectReleaseTab('frontend')">
                      <i class="bi bi-window me-1"></i>Frontend
                    </button>
                  </li>
                </ul>

                <div class="p-3">
                  <!-- Summary Tab -->
                  <div *ngIf="selectedReleaseTab === 'summary'">
                    <div class="alert alert-info mb-3">
                      <i class="bi bi-info-circle me-2"></i>{{ versionHistory[0].summary.overview }}
                    </div>
                    <h6 class="text-primary mb-2"><i class="bi bi-star-fill me-1"></i>Key Highlights</h6>
                    <ul class="mb-0">
                      <li *ngFor="let highlight of versionHistory[0].summary.highlights">{{ highlight }}</li>
                    </ul>
                  </div>

                  <!-- Backend Tab -->
                  <div *ngIf="selectedReleaseTab === 'backend'">
                    <div *ngIf="versionHistory[0].backend.features && versionHistory[0].backend.features.length > 0" class="mb-3">
                      <h6 class="text-success"><i class="bi bi-stars me-1"></i>New Features ({{ versionHistory[0].backend.features.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let feature of versionHistory[0].backend.features">{{ feature }}</li>
                      </ul>
                    </div>
                    <div *ngIf="versionHistory[0].backend.improvements && versionHistory[0].backend.improvements.length > 0" class="mb-3">
                      <h6 class="text-info"><i class="bi bi-arrow-up-circle me-1"></i>Improvements ({{ versionHistory[0].backend.improvements.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let improvement of versionHistory[0].backend.improvements">{{ improvement }}</li>
                      </ul>
                    </div>
                    <div *ngIf="versionHistory[0].backend.bugFixes && versionHistory[0].backend.bugFixes.length > 0">
                      <h6 class="text-warning"><i class="bi bi-wrench-adjustable me-1"></i>Bug Fixes ({{ versionHistory[0].backend.bugFixes.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let fix of versionHistory[0].backend.bugFixes">{{ fix }}</li>
                      </ul>
                    </div>
                    <div *ngIf="!versionHistory[0].backend.features?.length && !versionHistory[0].backend.improvements?.length && !versionHistory[0].backend.bugFixes?.length" class="text-muted">
                      <i class="bi bi-info-circle me-1"></i>No backend changes in this release
                    </div>
                  </div>

                  <!-- Frontend Tab -->
                  <div *ngIf="selectedReleaseTab === 'frontend'">
                    <div *ngIf="versionHistory[0].frontend.features && versionHistory[0].frontend.features.length > 0" class="mb-3">
                      <h6 class="text-success"><i class="bi bi-stars me-1"></i>New Features ({{ versionHistory[0].frontend.features.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let feature of versionHistory[0].frontend.features">{{ feature }}</li>
                      </ul>
                    </div>
                    <div *ngIf="versionHistory[0].frontend.improvements && versionHistory[0].frontend.improvements.length > 0" class="mb-3">
                      <h6 class="text-info"><i class="bi bi-arrow-up-circle me-1"></i>Improvements ({{ versionHistory[0].frontend.improvements.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let improvement of versionHistory[0].frontend.improvements">{{ improvement }}</li>
                      </ul>
                    </div>
                    <div *ngIf="versionHistory[0].frontend.bugFixes && versionHistory[0].frontend.bugFixes.length > 0">
                      <h6 class="text-warning"><i class="bi bi-wrench-adjustable me-1"></i>Bug Fixes ({{ versionHistory[0].frontend.bugFixes.length }})</h6>
                      <ul class="mb-0">
                        <li *ngFor="let fix of versionHistory[0].frontend.bugFixes">{{ fix }}</li>
                      </ul>
                    </div>
                    <div *ngIf="!versionHistory[0].frontend.features?.length && !versionHistory[0].frontend.improvements?.length && !versionHistory[0].frontend.bugFixes?.length" class="text-muted">
                      <i class="bi bi-info-circle me-1"></i>No frontend changes in this release
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Release History Tab -->
          <div *ngIf="selectedTab === 'history'" class="tab-pane fade show active">
            <div class="row">
              <!-- Release List (Left Sidebar) -->
              <div class="col-md-4">
                <div class="list-group">
                  <button
                    *ngFor="let release of versionHistory"
                    type="button"
                    class="list-group-item list-group-item-action"
                    [class.active]="selectedRelease?.version === release.version"
                    (click)="selectRelease(release)"
                  >
                    <div class="d-flex w-100 justify-content-between">
                      <h6 class="mb-1">
                        <span class="badge {{ getVersionBadgeClass(release.type) }} me-2">
                          <i class="{{ getVersionIcon(release.type) }} me-1"></i>v{{ release.version }}
                        </span>
                      </h6>
                      <small>{{ getChangeCount(release) }} changes</small>
                    </div>
                    <small class="text-muted"><i class="bi bi-calendar3 me-1"></i>{{ release.releaseDate }}</small>
                  </button>
                </div>
              </div>

              <!-- Release Details (Right Content) -->
              <div class="col-md-8" *ngIf="selectedRelease">
                <div class="card">
                  <div class="card-header bg-light">
                    <h5 class="mb-0">
                      <span class="badge {{ getVersionBadgeClass(selectedRelease.type) }} me-2">
                        <i class="{{ getVersionIcon(selectedRelease.type) }} me-1"></i>v{{ selectedRelease.version }}
                      </span>
                      <small class="text-muted">{{ selectedRelease.releaseDate }}</small>
                    </h5>
                  </div>
                  <div class="card-body p-0">
                    <!-- Sub-tabs for each release -->
                    <ul class="nav nav-tabs px-3 pt-2 mb-0">
                      <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedReleaseTab === 'summary'" (click)="selectReleaseTab('summary')">
                          <i class="bi bi-clipboard-data me-1"></i>Summary
                        </button>
                      </li>
                      <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedReleaseTab === 'backend'" (click)="selectReleaseTab('backend')">
                          <i class="bi bi-server me-1"></i>Backend
                        </button>
                      </li>
                      <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedReleaseTab === 'frontend'" (click)="selectReleaseTab('frontend')">
                          <i class="bi bi-window me-1"></i>Frontend
                        </button>
                      </li>
                    </ul>

                    <div class="p-3" style="max-height: 500px; overflow-y: auto;">
                      <!-- Summary Tab -->
                      <div *ngIf="selectedReleaseTab === 'summary'">
                        <div class="alert alert-info mb-3">
                          <i class="bi bi-info-circle me-2"></i>{{ selectedRelease.summary.overview }}
                        </div>
                        <h6 class="text-primary mb-2"><i class="bi bi-star-fill me-1"></i>Key Highlights</h6>
                        <ul class="mb-0">
                          <li *ngFor="let highlight of selectedRelease.summary.highlights">{{ highlight }}</li>
                        </ul>
                      </div>

                      <!-- Backend Tab -->
                      <div *ngIf="selectedReleaseTab === 'backend'">
                        <div *ngIf="selectedRelease.backend.features && selectedRelease.backend.features.length > 0" class="mb-3">
                          <h6 class="text-success"><i class="bi bi-stars me-1"></i>New Features</h6>
                          <ul>
                            <li *ngFor="let feature of selectedRelease.backend.features">{{ feature }}</li>
                          </ul>
                        </div>
                        <div *ngIf="selectedRelease.backend.improvements && selectedRelease.backend.improvements.length > 0" class="mb-3">
                          <h6 class="text-info"><i class="bi bi-arrow-up-circle me-1"></i>Improvements</h6>
                          <ul>
                            <li *ngFor="let improvement of selectedRelease.backend.improvements">{{ improvement }}</li>
                          </ul>
                        </div>
                        <div *ngIf="selectedRelease.backend.bugFixes && selectedRelease.backend.bugFixes.length > 0">
                          <h6 class="text-warning"><i class="bi bi-wrench-adjustable me-1"></i>Bug Fixes</h6>
                          <ul>
                            <li *ngFor="let fix of selectedRelease.backend.bugFixes">{{ fix }}</li>
                          </ul>
                        </div>
                        <div *ngIf="!selectedRelease.backend.features?.length && !selectedRelease.backend.improvements?.length && !selectedRelease.backend.bugFixes?.length" class="text-muted">
                          <i class="bi bi-info-circle me-1"></i>No backend changes in this release
                        </div>
                      </div>

                      <!-- Frontend Tab -->
                      <div *ngIf="selectedReleaseTab === 'frontend'">
                        <div *ngIf="selectedRelease.frontend.features && selectedRelease.frontend.features.length > 0" class="mb-3">
                          <h6 class="text-success"><i class="bi bi-stars me-1"></i>New Features</h6>
                          <ul>
                            <li *ngFor="let feature of selectedRelease.frontend.features">{{ feature }}</li>
                          </ul>
                        </div>
                        <div *ngIf="selectedRelease.frontend.improvements && selectedRelease.frontend.improvements.length > 0" class="mb-3">
                          <h6 class="text-info"><i class="bi bi-arrow-up-circle me-1"></i>Improvements</h6>
                          <ul>
                            <li *ngFor="let improvement of selectedRelease.frontend.improvements">{{ improvement }}</li>
                          </ul>
                        </div>
                        <div *ngIf="selectedRelease.frontend.bugFixes && selectedRelease.frontend.bugFixes.length > 0">
                          <h6 class="text-warning"><i class="bi bi-wrench-adjustable me-1"></i>Bug Fixes</h6>
                          <ul>
                            <li *ngFor="let fix of selectedRelease.frontend.bugFixes">{{ fix }}</li>
                          </ul>
                        </div>
                        <div *ngIf="!selectedRelease.frontend.features?.length && !selectedRelease.frontend.improvements?.length && !selectedRelease.frontend.bugFixes?.length" class="text-muted">
                          <i class="bi bi-info-circle me-1"></i>No frontend changes in this release
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <div class="me-auto text-muted small">
          <i class="bi bi-info-circle me-1"></i>
          Semantic Versioning (MAJOR.MINOR.PATCH)
        </div>
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>
